import React, { useEffect } from 'react';
import './Notification.css';

export type NotificationType = 'success' | 'error' | 'info' | 'warning';

export interface Notification {
  id: string;
  message: string;
  type: NotificationType;
}

interface NotificationProps {
  notification: Notification;
  onClose: (id: string) => void;
}

const NotificationItem: React.FC<NotificationProps> = ({ notification, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(notification.id);
    }, 5000); // Auto-close after 5 seconds

    return () => clearTimeout(timer);
  }, [notification.id, onClose]);

  return (
    <div className={`notification notification-${notification.type}`}>
      <div className="notification-content">
        <span className="notification-message">{notification.message}</span>
        <button
          className="notification-close"
          onClick={() => onClose(notification.id)}
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default NotificationItem;

